import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useErrorContext } from './../../components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';
import { useLocale } from './../../components/special/LanguageProvider';
import { apiGetCall, apiPostCall, isResultOk } from './../../components/special/apiCall';
import  EditForm  from 'components/form/EditForm';
import InputText from './../../components/input/InputText';
import  EditFormFieldTable  from 'components/form/EditFormFieldTable';
import InputDate from './../../components/input/InputDate';
import InputNumber from './../../components/input/InputNumber';
import InputDropDownList from 'components/input/InputDropDownList';
import ListTable from './../../components/form/ListTable';
import RowButtons from './../../components/button/RowButtons';
import RowDeleteButton from './../../components/button/RowDeleteButton';
import TextNumber from 'components/text/TextNumber';
import TextPercent from './../../components/text/TextPercent';
import TextAmount from 'components/text/TextAmount';
import ReactTooltip from 'react-tooltip';
import InputAmount from './../../components/input/InputAmount';

const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const CollectionFeeEdit = ({history}) => {
  
  const params = new URLSearchParams(useLocation().search);  
  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();
  const { t } = useLocale();

   //Init blank formdata record.
   const [formData, setFormData] = useState({isNew : true});  

  //Init blank working data record
  const [workingData, setWorkingData] = useState({
    collectionFeeID: null,    
    accessKey: "",
    name: "",
    isDeletable: true,
    transactionKeyID: null,
    linkedCollectionFeeID: null,
    feeDate: {
        collectionFeeDateID : null,
        validFromDate : new Date(),
        collectionBaseFee : 0,
        pleaOrMeetFee : 0,
        repossessPleaFee : 0,
        cancelFee : 0,
        delayFee : 0,
    },
    feeIncrementals: [],
  });

  const [feeIncremental, setFeeIncremental] = useState({
    collectionFeeIncrementalID : null,
    percentage : null,
    pointAmount : null,
    amount : null
  });

  const [lookupData, setLookupData] = useState({        
    transactionKeyList : [],
    collectionFeeList : [],
  });


  const loadLookupData = async() =>{
    //Load all the data at the same time.     
    let [transactionKeyList, collectionFeeList] = await Promise.all([
      apiGetCall(BASE_URL + '/admin/list/transactionkey/cost' ),
      apiGetCall(BASE_URL + '/admin/list/collectionfee' ),
    ]);           
    //Check we need to display any critical errors.
    setCheckErrorItems([transactionKeyList, collectionFeeList]);            

    //Translate the data into what we want to use.
    setLookupData( {
      transactionKeyList : transactionKeyList,
      collectionFeeList : collectionFeeList
    });
  }

  const goBack = () => {
    history.push("/admin/collectionfees");
  }

  const loadFormData = async() => {
    setIsPageLoading(true);
    let newFormData = {...formData};    
    //Read the query parameters, if we don´t have any then go back to transaction keys.
    let isNew = params.get("new");    
    if (!isNew){
      let editID = params.get("collectionfeeid");    
      if (editID == null || editID <= 0){      
        goBack();
      }    
      else{
        newFormData.isNew = false;      
        let requestResult = await apiGetCall(BASE_URL + '/admin/collectionfee/' + editID);       
        console.log("collectionfee", requestResult);
        if (isResultOk(requestResult, setCheckErrorItems)){        
          setWorkingData(requestResult);                
        }  
      }
    }
    
    await loadLookupData();

    setFormData(newFormData);
    setIsPageLoading(false);
  }

  useEffect(() => {
    loadFormData();
  }, []);

  const onSaveClick = async() => {
    setIsPageLoading(true);
    let requestResult = null;
    if (formData.isNew){      
      requestResult = await apiPostCall(BASE_URL + '/admin/collectionfee/create', workingData);       
    }
    else{      
      requestResult = await apiPostCall(BASE_URL + '/admin/collectionfee/change', workingData);       
    }    
    if (isResultOk(requestResult, setCheckErrorItems)){          
      goBack();
    }
    setIsPageLoading(false);    
  }

  const onBackClick = () => {    
    goBack();
  }

  
  const validateInput = async () => {
    let messages = [];      
    if (!workingData.feeDate.validFromDate){
      messages.push("Vantar dagsetningu");      
    }
    if (!workingData.name || workingData.name === ""){
      messages.push("Vantar nafn");      
    }
    if (workingData.transactionKeyID == null){
      messages.push("Vantar að velja færslulykill fyrir innheimtulaun.");      
    }    
    return messages; 
  }

  const onAddIncementalClick = () => {    
    let newList = [...workingData.feeIncrementals];    
    if (!feeIncremental.percentage) feeIncremental.percentage = 0;
    if (!feeIncremental.pointAmount) feeIncremental.pointAmount = 0;
    if (!feeIncremental.amount) feeIncremental.amount = 0;      
    newList.push(feeIncremental);
    setWorkingData({...workingData, feeIncrementals : newList});
    setFeeIncremental({...setFeeIncremental, percentage :null, pointAmount: null, amount: null });
  }

  const onDeleteIncementalClick = (item) => {
    var indexOfItem = workingData.feeIncrementals.indexOf(item);
    if (indexOfItem > -1){      
      workingData.feeIncrementals.splice(indexOfItem,1);
      setWorkingData({...workingData, feeIncrementals : workingData.feeIncrementals});
    }
  }

    
  return (
    <EditForm title={formData.isNew ? "Nýskrá innheimtuþóknun" : "Breyta innheimtuþóknun"} onSubmitClick={onSaveClick} onBackClick={onBackClick} onValidate={validateInput}>
      <EditFormFieldTable fields={[
        {
            title: t("Heiti innheimtuþóknunar"),
            edit : () => <InputText name="Name" disabled={!formData.isNew} value={workingData.name} onChange={(value) => setWorkingData({ ...workingData, name : value})}/>          
        },
        {
            title: t("Nr"),
            edit : () => <InputNumber name="AccessKey" disabled={!formData.isNew} max={999} value={workingData.accessKey} onChange={(value) => setWorkingData({ ...workingData, accessKey : value})}/>          
        },
        {
            title: t("Gildir frá"),
            edit : () => <InputDate name="ValidFromDate" value={workingData.feeDate.validFromDate} onChange={(value) =>setWorkingData({ ...workingData, feeDate:{ ...workingData.feeDate, validFromDate : value}})}/>
        },          
        {
            title: t("Grunngjald"),
            edit : () => <InputAmount name="CollectionBaseFee" value={workingData.feeDate.collectionBaseFee} onChange={(value) => setWorkingData({ ...workingData, feeDate:{ ...workingData.feeDate, collectionBaseFee : value}})}/>
        },          
        {
            title: t("Kostnaður við beiðni og mót"),
            edit : () => <InputAmount name="PleaOrMeetFee" value={workingData.feeDate.pleaOrMeetFee} onChange={(value) => setWorkingData({ ...workingData, feeDate:{ ...workingData.feeDate, pleaOrMeetFee : value}})}/>
        },          
        {
            title: t("Kostnaður vörslusviptingar"),
            edit : () => <InputAmount name="RepossessPleaFee" value={workingData.feeDate.repossessPleaFee} onChange={(value) => setWorkingData({ ...workingData, feeDate:{ ...workingData.feeDate, repossessPleaFee : value}})}/>
        },          
        {
            title: t("Kostnaður afturköllunar máls"),
            edit : () => <InputAmount name="CancelFee" value={workingData.feeDate.cancelFee} onChange={(value) => setWorkingData({ ...workingData, feeDate:{ ...workingData.feeDate, cancelFee : value}})}/>
        },          
        {
            title: t("Kostnaður við frestun máls"),
            edit : () => <InputAmount name="DelayFee" value={workingData.feeDate.delayFee} onChange={(value) => setWorkingData({ ...workingData, feeDate:{ ...workingData.feeDate, delayFee : value}})}/>
        },        
        {
            title: t("Málskostnaður tekur gjöld"),
            edit : () => <InputDropDownList
                          name="LinkedCollectionFeeID"                          
                          list={lookupData.collectionFeeList}
                          keyField="itemID"
                          displayField = { (item) => { return item.name + " " + (item.data ? "("+item.data.accessKey+")" : ""); } }
                          defaultValue = {workingData.linkedCollectionFeeID}
                          onChange={(value) => setWorkingData({ ...workingData, linkedCollectionFeeID : value})}
                          nullable={true}
                          nullableItem={{itemID: null, name: ""}}
                        />          
        },            
        {
            title: t("Innheimtulaun bókast á kostnaðarlykilinn"),
            edit : () => <InputDropDownList
                          name="TransactionKeyID"                          
                          list={lookupData.transactionKeyList}
                          keyField="itemID"
                          displayField = { (item) => { return item.name + " " + (item.data ? "("+item.data.key+")" : ""); } }
                          defaultValue = {workingData.transactionKeyID}
                          onChange={(value) => setWorkingData({ ...workingData, transactionKeyID : value})}
                          nullable={true}
                          nullableItem={{itemID: null, name: ""}}
                        />          
        }
      ]}/>                                                                                

      <div>
        <ReactTooltip/>        
         <div className="table-wrap">
           <table className="table advanced hover ">
              <colgroup>
                <col width="25%"/>
                <col width="25%"/>
                <col width="25%"/>
                <col width=""/>
              </colgroup>
            <thead>
            <tr>                
              <th className="no-right-border no-left-border text-right">{t("Prósentuhækkun (%)")}</th>                                         
              <th className="no-right-border no-left-border text-right">{t("Föst hækkun (kr)")}</th>
              <th className="no-right-border no-left-border text-right">{t("Hækkunarstig (kr)")}</th>
              <th className="no-right-border no-left-border text-right"></th>
            </tr>
            </thead>
                <tbody>         
                    <tr>
                      <td className="form no-right-border no-left-border text-right"><InputNumber value={feeIncremental.percentage} max={100} onChange={(value) => setFeeIncremental({...feeIncremental, percentage : value})} decimalScale={2}/></td>
                      <td className="form no-right-border no-left-border text-right"><InputAmount value={feeIncremental.pointAmount} onChange={(value) => setFeeIncremental({...feeIncremental, pointAmount : value})}/></td>
                      <td className="form no-right-border no-left-border text-right"><InputAmount value={feeIncremental.amount} onChange={(value) => setFeeIncremental({...feeIncremental, amount : value})}/></td>
                      <td className="form no-right-border no-left-border text-right"><button className="button gray-light  icon-checkmark3 btn-border blue icon-small no-text" onClick={onAddIncementalClick}></button></td>
                    </tr>             
                    {workingData.feeIncrementals.sort((a, b) => a.amount - b.amount).map((item, index) =>             
                        <tr key={index}>                            
                          <td className="no-right-border no-left-border text-right"><TextPercent value={item.percentage}/></td>                                   
                          <td className="no-right-border no-left-border text-right"><TextAmount value={item.pointAmount}/></td>                                   
                          <td className="no-right-border no-left-border text-right"><TextAmount value={item.amount}/></td>                                   
                          <td className="no-right-border no-left-border text-right"><RowButtons>
                                                                                      <RowDeleteButton onClick={() => onDeleteIncementalClick(item)}/>                        
                                                                                    </RowButtons></td>                                   
                        </tr>
                    )}  
                    {workingData.feeIncrementals.length == 0 && (
                        <tr>
                            <td colSpan='4' className="no-right-border no-left-border text-center">{t("Engar færslur")}</td>   
                        </tr>
                    )}                            
                </tbody>
            </table>
            </div>         
      </div>        
    </EditForm>    
  );
}